<script setup lang="ts">
interface RootProps {
  startPage: string;
  query: string;
  folder: string;
}

defineProps<RootProps>()
</script>

<template>
  <div>
    <component
      :is="startPage" 
      :query="query"
      :folder="folder"
    />
  </div>
</template>